import Dispatcher from '../dispatcher';
import Constants from '../constants.js/Constant';
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');

var TRANSLATION_CHANGE_EVENT = 'translationChange';
var bundle = {};

function parseBundle(data) {
    if (data != null) { bundle = data; }
}

var GetTranslationStore = assign({}, EventEmitter.prototype, {
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(TRANSLATION_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(TRANSLATION_CHANGE_EVENT, callback);
    },
    getBundle: function () {
        return bundle;
    }
});

Dispatcher.register(function (action) {
    switch (action.actionType) {
        case Constants.GET_TRANSLATION:
            parseBundle(action.data);
            GetTranslationStore.emitChangeEvent(TRANSLATION_CHANGE_EVENT);
            break;
        default:
    }
});

export default GetTranslationStore;
